module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-cjdr.78d93a16.png";